import { axiosInterceptor, apiCall } from 'services'
import { API_BASE_URL } from './constants'

const tasksService = () => {
	const api = axiosInterceptor(API_BASE_URL)

	// CREATE
	const createTask = async (task: any) => await apiCall(api.post('/tasks', task))

	// READ
	const getTasks = async ({
		userid,
		packageid,
		projectid,
	}: {
		userid: string
		packageid: string
		projectid: string
	}) =>
		await apiCall(
			api.get('tasks/mypackageid', {
				params: {
					userid,
					packageid,
					projectid,
				},
			}),
		)

	// UPDATE
	const updateTask = async (task: any) => await apiCall(api.put(`/tasks/${task._id}`, task))

	// DELETE
	const deleteTask = async (id: string) => await apiCall(api.put(`/tasks/${id}/delete`))

	// READ
	const getMyAssigned = async ({ assignedTo }: { assignedTo: string }) =>
		await apiCall(
			api.get('tasks/myassigned', {
				params: {
					assignedTo,
				},
			}),
		)

	// OTHER
	const loadTemplateIntoTasks = async (template: any) =>
		await apiCall(api.post('/tasks/template', template))

	return {
		createTask,
		getTasks,
		updateTask,
		deleteTask,
		getMyAssigned,
		loadTemplateIntoTasks,
	}
}

export default tasksService
